<template>
    <div class="pagination">
        <button @click="prevPage" v-if="pageNumber > 0" class="btn border" >&lt;&lt;</button>
        <span>Page : {{pageNumber + 1}} / {{pageCount + 1}} </span>
        <button @click="nextPage" v-if="pageNumber < pageCount" class="btn border">>></button>
    </div>
</template>

<script>
export default {
    name: 'ListPagination',      
    props: {
        listData:{
            type:Array,
            required:true
        },
        itemByPage:{
            type:Number,
            required:false,
            default: 10
        }, 
        pageNumber: {
            type:Number,
            required:true
        }
    },
    methods: {
        nextPage(){
            if(this.pageNumber < this.pageCount)
                this.$emit("update-page-number", "next");                            
        },
        prevPage(){
            if(this.pageNumber > 0)
                this.$emit("update-page-number", "previous");                        
        }
    },
    computed: {
        pageCount(){
            let l = this.listData.length,
                s = this.itemByPage;
            return Math.ceil(l/s)-1;
        }
    }

}
</script>
<style>

</style>